import type { Unsubscribe } from '@amazon/vinyl-util'

/**
 * Adds a listener to the image when it has finished loading and decoding.
 *
 * @param img
 * @param callback
 * @return Returns a function to unsubscribe the listener.
 */
export function onImageDecode(img: HTMLImageElement, callback: () => void): Unsubscribe {
    const loadHandler = () => {
        void (async () => {
            if ('decode' in img) await img.decode()
            callback()
        })()
    }
    img.addEventListener('load', loadHandler)
    return () => img.removeEventListener('load', loadHandler)
}
